import { Nav, Navbar } from "react-bootstrap";
import { startTransition, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import TogglerCollapsedIcon from "../../../images/icons/navMenu/togglerCollapsed.svg?react";
import TogglerExpendedIcon from "../../../images/icons/navMenu/togglerExpended.svg?react";
import CreateOrderIcon from "../../../images/icons/navMenu/createOrder.svg?react";
import { useClearingOrder } from "../../../hooks/useClearingOrder";
import { BsGear, BsPersonPlus } from "react-icons/bs";
import { routes } from "../../../app/routes/routes";
import { useLocation, useNavigate } from "react-router";
import { useUserRole } from "../../../hooks/useUserRole";
import { UserRolesEnum } from "../../../app/enums/userRolesEnum";
import { sideNavItems } from "./sideNavItems";
import "./SideNavbar.scss";

const SideNavbar = () => {
    const [expanded, setExpanded] = useState(true);
    const [clearOrder] = useClearingOrder();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { session, renderIfHasRole } = useUserRole();
    const location = useLocation();

    const toggleSidebar = () => {
        setExpanded(!expanded);
    };

    const handleCreateOrderClick = () => {
        startTransition(() => {
            clearOrder();
            navigate(routes.ordering.path);
        });
    };

    const isActiveRoute = useCallback(
        (path: string) => {
            return location.pathname === path;
        },
        [location.pathname]
    );

    return (
        <Navbar className={`side-bar ${expanded ? "expanded" : "collapsed"}`} data-bs-theme="dark">
            <Nav>
                <Nav.Item className="create-order">
                    <Nav.Link onClick={handleCreateOrderClick}>
                        <div className={`create-content ${expanded ? "expanded" : "collapsed"}`}>
                            <CreateOrderIcon title={`${t("navbar.sidebar.linkTitels.createOrder")} icon`} />
                            <span className="nav-link-text">{t("navbar.sidebar.linkTitels.createOrder")}</span>
                        </div>
                    </Nav.Link>
                </Nav.Item>

                {sideNavItems.map(({ key, route, icon, labelKey, requireAuth }) => {
                    if (requireAuth && !session) return null;
                    return (
                        <Nav.Item key={key}>
                            <Nav.Link onClick={() => navigate(route)} className={isActiveRoute(route) ? "active" : ""}>
                                {icon}
                                <span className="nav-link-text">{t(`navbar.sidebar.linkTitels.${labelKey}`)}</span>
                            </Nav.Link>
                        </Nav.Item>
                    );
                })}

                {renderIfHasRole(
                    <Nav.Item key="adminPanel">
                        <Nav.Link
                            onClick={() => navigate(routes.adminPanel.path)}
                            className={isActiveRoute(routes.adminPanel.path) ? "active" : ""}
                        >
                            <BsGear style={{ minHeight: "24px", minWidth: "24px" }} />
                            <span className="nav-link-text">{t("navbar.sidebar.linkTitels.adminPanel")}</span>
                        </Nav.Link>
                    </Nav.Item>,
                    [UserRolesEnum.Admin]
                )}

                {renderIfHasRole(
                    <Nav.Item key="registerUser">
                        <Nav.Link
                            onClick={() => navigate(routes.signUp.path)}
                            className={isActiveRoute(routes.signUp.path) ? "active" : ""}
                        >
                            <BsPersonPlus style={{ minHeight: "24px", minWidth: "24px" }} />
                            <span className="nav-link-text">{t("navbar.sidebar.linkTitels.registerUser")}</span>
                        </Nav.Link>
                    </Nav.Item>,
                    [UserRolesEnum.Admin]
                )}

                <Nav.Item>
                    <Nav.Link
                        onClick={toggleSidebar}
                        aria-controls="left-navbar-collapse"
                        type="button"
                        aria-label="Toggle navigation"
                    >
                        {expanded ? (
                            <TogglerExpendedIcon title={`${t("navbar.sidebar.linkTitels.toggleMenu")} icon`} />
                        ) : (
                            <TogglerCollapsedIcon title={`${t("navbar.sidebar.linkTitels.toggleMenu")} icon`} />
                        )}
                        <span className="nav-link-text">{t("navbar.sidebar.linkTitels.toggleMenu")}</span>
                    </Nav.Link>
                </Nav.Item>
            </Nav>
        </Navbar>
    );
};
export default SideNavbar;
